import { createActions } from 'redux-actions';

export const { updateGuestEventsRequests } = createActions('UPDATE_GUEST_EVENTS_REQUESTS');
